// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__Ffx4D","mainContainer":"layout_mainContainer__DUXLn"};